/* global attachEvent */

window.addEventListener('spectoCmsContentLoaded', () => {
  injection.attachEvent('.open-search', 'click', (openSearch) => {
    const parent = openSearch.target.closest('.breadcrumbs');
    parent.classList.toggle('is-active');

    const inputElement = parent.querySelector('input');
    // eslint-disable-next-line no-unused-expressions
    parent.classList.contains('is-active') ? inputElement.focus() : inputElement.blur();
  });

  // Disable submit button if action is not set
  window.breadcrumbsSearchForm = document.querySelector('[data-search-form]');
  window.submitButton = breadcrumbsSearchForm?.querySelector('button');

  if (!breadcrumbsSearchForm?.getAttribute('action')) {
    submitButton?.setAttribute('disabled', true);
  }
});
